import type { AnalyticsInstance } from 'analytics'

interface CreateConsentSettingsChangedEventOptions {
  settingsEncoded: string
}

export const createConsentSettingsChangedEvent = (
  options: CreateConsentSettingsChangedEventOptions
): Parameters<AnalyticsInstance['track']> => ['consentSettingsChanged', options]
